import React, { useEffect, useState } from "react";
import { Row, Col, message, Spin } from "antd";
import FeedbackCard from "./FeedbackCard";
import useFeedbackFormService from "../../../../services/feedbackFormService";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";
import ShareFormModal from "./ShareFormModal";
import useQRCodeService from "../../../../services/qrCodeService";

const FeedbackList = ({ forms, setForms, onEdit, onDelete, onView }) => {
  const [loading, setLoading] = useState(false);
  const [shareForm, setShareForm] = useState(null);
  const [exampleForm, setExampleForm] = useState(null);
  const { language } = useLanguage();
  const { getFeedbackForms, getExampleForm } = useFeedbackFormService();
  const { getQRCodes } = useQRCodeService();
  const text = dashboardContent[language].feedback.list;

  const [qrCodes, setQRCodes] = useState([]);

  // Fetch all regular forms once on mount
  useEffect(() => {
    const fetchForms = async () => {
      setLoading(true);
      try {
        const data = await getFeedbackForms();
        setForms(data);
      } catch (error) {
        console.error(
          "Fehler beim Laden der Feedback-Formulare:",
          error.message
        );
      }
      setLoading(false);
    };

    fetchForms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch example form once on mount
  useEffect(() => {
    const fetchExample = async () => {
      try {
        const form = await getExampleForm();
        if (form) {
          setExampleForm({ ...form, isExample: true });
        }
      } catch (error) {
        console.error(
          "Fehler beim Laden des Beispiel-Formulars:",
          error.message
        );
      }
    };

    fetchExample();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch QR codes once on mount
  useEffect(() => {
    const fetchQRCodes = async () => {
      try {
        const codes = await getQRCodes();
        setQRCodes(codes.qrCodes || []);
      } catch (error) {
        console.error("Fehler beim Laden der QR-Codes:", error.message);
      }
    };
    fetchQRCodes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleShare = (form) => {
    setShareForm(form);
  };

  // Combine example form (if exists) and regular forms
  const displayForms = exampleForm ? [exampleForm, ...(forms || [])] : forms;

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <Spin size="large" style={{ display: "block", textAlign: "center" }} />
      ) : !displayForms || displayForms.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          {text.empty}
        </div>
      ) : (
        <Row gutter={[16, 16]}>
          {displayForms.map((form) => (
            <Col xs={24} sm={12} md={8} key={form._id}>
              <FeedbackCard
                form={form}
                isExample={form.isExample}
                onEdit={onEdit}
                onDelete={onDelete}
                onView={onView}
                onShare={handleShare}
              />
            </Col>
          ))}
        </Row>
      )}
      <ShareFormModal
        open={!!shareForm}
        onClose={() => setShareForm(null)}
        form={shareForm}
        qrCode={qrCodes.find((qr) => qr.feedbackForm._id === shareForm?._id)}
      />
    </div>
  );
};

export default FeedbackList;
